import React from "react";
import Icon, {
  AudioOutlined,
  AudioMutedOutlined,
  PushpinOutlined,
  CameraOutlined,
  DesktopOutlined,
  LikeOutlined,
  CloseSquareOutlined
} from "@ant-design/icons";

// import Icon from "@ant-design/icons";

import { ReactComponent as CameraDisable } from "@/assets/camera-disable.svg";
import { ReactComponent as Camera } from "@/assets/camera.svg";

import { ReactComponent as SoundDisable } from "@/assets/soundmute.svg";
import { ReactComponent as Sound } from "@/assets/sound.svg";

interface PropType {
  active: boolean;
}

export const AudioIcon = ({ active }: PropType) => {
  return active ? (
    <AudioOutlined />
  ) : (
    <AudioMutedOutlined className="color-danger" />
  );
};

export const CloseSquareIcon = ({ active }: PropType) => {
  return active ? (
    <CloseSquareOutlined />
  ) : (
    <CloseSquareOutlined className="color-danger" />
  );
};

export const VideoIcon = ({ active }: PropType) => {
  return active ? (
    <Icon component={Camera} width={16} height={16} />
  ) : (
    <Icon
      component={CameraDisable}
      className="color-danger"
      width={16}
      height={16}
    />
  );
};

export const SoundIcon = ({ active }: PropType) => {
  return active ? (
    <Icon component={Sound} width={16} height={16} />
  ) : (
    <Icon
      component={SoundDisable}
      className="color-danger"
      width={16}
      height={16}
    />
  );
};

export const ShareIcon = ({ active }: PropType) => {
  return active ? (
    <DesktopOutlined />
  ) : (
    <DesktopOutlined className="color-danger" />
  );
};

export const HandIcon = ({ active }: PropType) => {
  return active ? <LikeOutlined /> : <LikeOutlined className="color-danger" />;
};

export const PinIcon = ({ active }: PropType) => {
  return active ? <PushpinOutlined /> : <PushpinOutlined />;
};
